<template>
    <div class="form-group">
        <label>
            <localized-text localizedKey="Numero di rate" text="Numero di rate"></localized-text>
        </label>
        <input type="number" class="form-control" v-model="localValue.number" />
    </div>
    <div class="form-group">
        <label>
            <localized-text localizedKey="Importo di ogni rata" text="Importo di ogni rata"></localized-text>
        </label>
        <input type="number" class="form-control" v-model="localValue.amount" />
    </div>
    <div class="form-group">
        <label>
            <localized-text localizedKey="Genera un voucher su questi numeri rata" text="Genera un voucher su questi numeri rata"></localized-text>
        </label>
        <div class="mb-1">
            <button class="btn btn-primary" @click="add">
                <icon-plus />
            </button>
        </div>
        <div class="d-flex" v-for="(item, i) in localValue.createVacationVoucherOnNumbers">
            <input type="number" class="form-control" v-model="localValue.createVacationVoucherOnNumbers[i]" />
            <button class="btn btn-danger" @click="remove(i)">
                <icon-minus></icon-minus>
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { mixins, Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { Prop, Watch } from 'vue-property-decorator';
import { insertAllLanguages } from '@/utils';
import store from '@/store';
import { LocalizedClient } from '@/services/Services';
import WithModel from '@/mixins/withModel';

@Options({})
export default class membershipInstallmentConfig extends mixins(WithModel) {

    declare localValue: OM.MembershipInstallmentConfig
    
    add(){
        this.localValue.createVacationVoucherOnNumbers.push(0);
    }

    remove(i){
        this.localValue.createVacationVoucherOnNumbers.splice(i, 1);
    }

}
</script>
<style scoped>
</style>